import { ControlSpecificValidation } from '../../types';
import { validateSsn } from './ssn-validator';
import { validateIban } from './iban-validator';
import { validateIdNumber } from './id-number-validator';

const specificValidations: { [key: string]: ControlSpecificValidation } = {
    'personalInfo.ssn': validateSsn,
    'applicant.personalInfo.ssn': validateSsn,
    'coapplicant.personalInfo.ssn': validateSsn,
    'mainApplicant.ssn': validateSsn, // LTU
    'coApplicant.ssn': validateSsn, // LTU
    'mortgageData.primaryCollateral.ownerSsn': validateSsn, // EstMortage
    'mortgageData.secondaryCollateral.ownerSsn': validateSsn, // EstMortage
    'customer.personalInfo.ssn': validateSsn, // LVA (Atlas)

    'applicant.identification.number': validateIdNumber,
    'coapplicant.identification.number': validateIdNumber,

    'bankInfo.iban': validateIban,
    'refinData.lenderItems.lenderIban': validateIban,
    iban: validateIban,
};

export default specificValidations;
